// difficulty weights
export const DIFFICULTY_WEIGHTS = {
  l1: 0.35,
  l2: 0.45,
  l3: 0.20,
};

// accuracy lookup by level
export const ACCURACY_TABLE = {
  "1": [0.60, 0.40, 0.25],
  "1-2": [0.90, 0.40, 0.25],
  "2": [0.95, 0.75, 0.40],
  "2-3": [0.95, 0.90, 0.40],
  "3": [0.95, 0.95, 0.75],
  "4": [0.95, 0.95, 0.90],
};

export const ACCURACY_DELTA = 0.05;
export const TOTAL_QUESTIONS = 66;
